import { create } from "zustand";

const initialFormState = {
  loading: false,
  errors: {} as Record<string, string>,
  values: {} as Record<string, string | boolean | number>,
};

export type FormState = typeof initialFormState;

export const useFormStore = create<FormState>(() => ({
  ...initialFormState,
}));
